<template>
    <transition name="slide-fade">
        <div class="modal" :class="{'open' : open}" v-if="open">
            <div class="modal-content">
                <div class="bg-white w-full rounded-xl p-3">
                    <div class="text-center text-lg pb-5 pt-3">
                        <div class="relative">
                            <div v-if="tag == 'surprise-point'">
                                <img class="w-56 h-40 mx-auto -mt-24" src="../assets/bg-confirm-surprise-point.png" alt="">
                                <div class="-mt-36">
                                    <div class="text-blue-1 text-24 font-bold">คุณได้รับฟรี</div>
                                    <div class="text-green-1 text-34 leading-6 font-bold">{{ campaignPoint }} {{ lbl.surprise.point_unit }}</div>
                                </div>
                            </div>

                            <div v-if="tag == 'surprise-campaign'">
                                <img class="w-56 h-40 mx-auto -mt-24" :src="campaign.fullImageUrl" alt="">
                            </div>

                            <div v-if="tag == 'surprise-campaign-delivery' || tag == 'surprise-campaign-delivery-success'">
                                <img class="w-56 h-40 mx-auto -mt-24" :src="campaign.fullImageUrl" alt="">
                            </div>

                            <div class="pb-3.5" :class="tag == 'surprise-point' ? 'mt-24' : ''">
                                <div v-if="title" class="text-center text-30 text-blue-1 pt-3" v-html="title"></div>
                                <div v-if="message" class="pt-3 text-22 text-gray-1" v-html="message"></div>
                            </div>
                        </div>

                    </div>
                    <div class="pb-6">
                        <button class="w-full bg-green-1 text-22 text-white rounded-r-full rounded-l-full py-2.5" @click="clickOk()">
                            {{btnOk}}
                        </button>

                        <div v-if="tag == 'surprise-campaign'" class="text-center">
                            <div class="text-green-1 text-20 underline mt-3" @click="clickCancel()">เก็บไว้ใช้ภายหลัง</div>
                            <div class="text-gray-1 text-20 mt-3">โค้ดส่วนลดถูกเก็บที่เมนู รีวอร์ด</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
import Util from "@/helper/Utility.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    name: "ConfirmModal",
    mixins: [LocaleMixin],
    props: {
        controller: Object,
    },
    data: function() {
        return {
            open: false,

            title: '',
            message: '',
            btnOk: '',
            btnCancel: '',
            busModal: null,
            tag: '',
            campaign: {},
            campaignPoint: 0,
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    methods: {
        show: function(config) {
            if(config.campaign){
                this.campaign = config.campaign;
                console.log('campaign', this.campaign)
            }

            if(config.point){
                this.campaignPoint = config.point;
            }
            this.title = config.title;
            this.btnOk = config.btnOk;
            this.btnCancel = config.btnCancel;
            this.tag = config.tag;

            if (Util.isEmptyStr(this.btnOk)) {
                this.btnOk = this.lbl.button.confirm;
            }
            if (Util.isEmptyStr(this.btnCancel)) {
                this.btnCancel = this.lbl.button.cancel;
            }

            document.body.classList.add('not-scroll');
            this.open = true;

            this.checkTag()
        },
        hide: function() {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk();
        },
        clickCancel: function() {
            this.hide();
            this.controller.sendCallbackCancel();
        },
        checkTag: function() {
            if(this.tag == 'surprise-full') {
                this.message = 'ขออภัย คุณไม่ได้รับของรางวัลจากการเปิดกล่อง S Plus+ แล้วพบกิจกรรมสนุกๆจาก S Plus+ ในครั้งถัดไป'
            } else if(this.tag == 'surprise-point') {
                this.message = Util.stringFormat(this.lbl.surprise.pre_point_msg, this.campaignPoint);
            } else if(this.tag == 'surprise-campaign') {
                this.message = this.campaign.name
            } else if(this.tag == 'surprise-campaign-delivery') {
                this.message = this.campaign.name
            } else if(this.tag == 'surprise-campaign-delivery-success') {
                this.message = 'ของรางวัลจะถูกจัดส่งไปตามที่อยู่ที่ระบุไว้ภายใน 14 วันทำการ ตรวจสอบเลขพัสดุการจัดส่งได้ที่หน้า ประวัติการใช้งาน'
            } else if(this.tag == 'check-point') {
                this.message = 'ขออภัย คะแนนของท่านไม่เพียงพอ ในการเข้าร่วมกิจกรรมนี้ ท่านสามารถเข้าร่วมกิจกรรมสนุกๆจาก S Plus+ ได้ในครั้งถัดไป'
            }
        }
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/modal.scss";
    .modal {
        @extend %modal;
        .modal-content {
            overflow: unset;
            width: 100%;
            max-width: 414px;
            padding: 0 16px;
        }
    }
</style>
